export default {
  manage_deletedCrew: "Crew was deleted successfully",
  manage_deletedCrews: "Crews were deleted successfully",
  manage_deleteManageCrew_deleteCrew: "Delete Crew",
  manage_deleteManageCrew_deleteCrews: "Delete Crews",
  manage_deleteManageCrew_confirmationMessage:
    "Are you sure you want to delete the following Crews?",
};
